import { render, staticRenderFns } from "./DialogWrapper.vue?vue&type=template&id=4f2f4e2e&scoped=true&"
import script from "./DialogWrapper.vue?vue&type=script&lang=js&"
export * from "./DialogWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2f4e2e",
  null
  
)

export default component.exports